import { Routes } from '@angular/router';

export const CUSTOMER_GROUPS_ROUTES: Routes = [
  {
    path: 'customer-groups/:id/billing-info',
    loadComponent: () =>
      import('./customer-groups-billing-info-form/customer-groups-billing-info-form.component')
        .then(m => m.CustomerGroupsBillingInfoFormComponent),
  },
  {
    path: 'customer-groups',
    loadComponent: () =>
      import('./customer-groups-list/customer-groups-list.component')
        .then(m => m.CustomerGroupsListComponent),
  }
];
